import StarterKit from '@tiptap/starter-kit';
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import Placeholder from '@tiptap/extension-placeholder';
import { Table } from '@tiptap/extension-table';
import { TableRow } from '@tiptap/extension-table-row';
import { TableHeader } from '@tiptap/extension-table-header';
import { TableCell } from '@tiptap/extension-table-cell';
import Youtube from '@tiptap/extension-youtube';
import { FigureImage } from './image-node';

/** 編輯器擴充清單：保留所有既有格式，加入自訂圖片、表格、YouTube 嵌入。 */
export const editorExtensions = [
  StarterKit.configure({ link: { openOnClick: false, autolink: true } }),
  FigureImage,
  Highlight,
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
  Table.configure({ resizable: true, HTMLAttributes: { class: 'tiptap-table' } }),
  TableRow,
  TableHeader,
  TableCell,
  Youtube.configure({ controls: true, nocookie: true, width: 640, height: 360 }),
  Placeholder.configure({ placeholder: '開始撰寫新聞內容…' }),
];
